import { PropsWithChildren } from "react"
import { Tooltip } from "@mui/material"

import { LocalizedStrict } from "../../../../../../../modules/localization/components/AppLocalized"

type EventTooltipProps = Readonly<PropsWithChildren<{}>>

export function EventTooltip({ children }: EventTooltipProps) {
    return (
        <LocalizedStrict id="create-order-calendar-event-tooltip" attrs={{ title: true }}>
            <Tooltip title="Click to book">
                <span>{children}</span>
            </Tooltip>
        </LocalizedStrict>
    )
}
